export default __webpack_public_path__ + "static/media/kumato-prosciutto-baguette.f95c92ae.jpg";